import { z } from 'zod';
/**
 * 患者代理キー。院内側で採番する不透明IDで、単独では患者を特定できない。
 * 生成方式はG1で確定するため、アプリ側は「不透明な文字列」以上の意味を持たせない。
 */
export const surrogateKeySchema = z
    .string()
    .min(8)
    .max(64)
    .regex(/^[A-Za-z0-9_-]+$/, '代理キーは英数字・ハイフン・アンダースコアのみ');
export const caseIdSchema = z.string().uuid();
/** epoch ミリ秒。画面の経過時間計算と同じ単位で扱う。 */
export const epochMsSchema = z.number().int().nonnegative();
/** べき等性キー。連打・再送で二重反映しないために全更新APIで必須。 */
export const requestIdSchema = z.string().uuid();
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD');
export const ROLES = ['clerk', 'pharm', 'nurse', 'admin'];
export const roleSchema = z.enum(ROLES);
/** 画面ID。確定済みHTMLのビュー構成と一致させる。 */
export const VIEWS = ['clerk', 'rx', 'nurse', 'board', 'stats', 'admin', 'monitor'];
export const viewSchema = z.enum(VIEWS);
//# sourceMappingURL=primitives.js.map